/**
 * Module dependencies.
 */

import { Container } from '../container/container';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled(Container)`
  padding-top: 60px;
  min-height: calc(100vh - 600px);

  @media (max-width: 768px) {
    padding-top: 40px;
  }

  @media (max-width: 576px) {
    padding-top: 60px;
  }
`;
